<template>
<div class="row"  v-if="material._destroy == undefined">
    <div class="col s1" style="width: 5px">
        <i class="material-icons dp48" style="line-height: 1.5;" v-on:click="removeMaterial(material)">close</i>
    </div>
    <div class="col s2">
        <select v-model="materialId">
          <option value="-1">Inny materiał...</option>
          <option v-for='material_item in material_items' :value="material_item.id">{{material_item.name}}</option>
        </select>
    </div><div class="col s2" v-if="materialId == -1">
        <input v-model="material.name"/>
    </div>
    <div class="col s1 label" style="text-align: right;">{{$t('intervention.quantity')}}</div>
    <div class="col s1 input-field">
        <input v-model="material.quantity" />
    </div>
    <div class="col s1">
        <select v-model="material.unit">
            <option value="grams">
                gram
            </option>
            <option value="meters">
                mb
            </option>
            <option value="pieces">
                szt
            </option>
            <option value="package">
                opakowań
            </option>
        </select>
    </div><div class="col s2">
        <input v-model="material.more"/>
    </div>
</div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
        return {}
    },
    mounted(){
    },
    methods: {
      removeMaterial: function(material){
        this.material._destroy = true
        this.$forceUpdate();
        this.$emit('removematerial', material);
      },
    },
    props: { material: Object, material_items: Array },
    computed: {
      materialId: {
        get: function() {
          if(_.isNil(this.material.material_item_id) || this.material.material_item_id == -1){
            return -1;
          }else{
            return this.material.material_item_id;
          }
        },
        set: function(value){
            if(value == -1){
              this.material.material_item_id = -1;
              this.material.name = "";
            }else{
              this.material.material_item_id = value;
            }
            this.$forceUpdate();
        }
      }
    },

}
</script>
<style scoped>
div {
    margin-left: auto;
    left: auto;
    right: auto;
    line-height: 2;
}
</style>